/** The rest as a ring that empties, redrawn with the clock. */
export function RestRing({ progress, over }: { progress: number; over: boolean }) {
  const radius = 11;
  const length = 2 * Math.PI * radius;
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" className="shrink-0 -rotate-90" aria-hidden>
      <circle cx="14" cy="14" r={radius} fill="none" stroke="var(--color-surface-high)" strokeWidth="3" />
      <circle
        cx="14"
        cy="14"
        r={radius}
        fill="none"
        stroke={over ? "var(--hue-a)" : "var(--color-ink)"}
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray={length}
        strokeDashoffset={over ? 0 : length * progress}
      />
    </svg>
  );
}
